import styled, { css } from 'styled-components';
import ResponsiveImage from '../../components/ResponsiveImage';
import { breakpointUp } from '../../../styles/mediaUtils';

const aspectRatioMixin = (ratio: string) => css`
  aspect-ratio: ${ratio};

  img,
  picture {
    aspect-ratio: ${ratio};
    object-fit: cover;
  }
`;

export const HeaderImage = styled(ResponsiveImage)`
  grid-column: 1 / -1;
  margin: 0 -1rem;
  width: auto;
  ${aspectRatioMixin('375 / 465')}

  @media ${breakpointUp.tablet} {
    margin: 0;
    ${aspectRatioMixin('720 / 716')}
  }

  @media ${breakpointUp.desktop} {
    ${aspectRatioMixin('1368 / 716')}
  }

  @media ${breakpointUp.desktopLarge} {
    ${aspectRatioMixin('1368 / 716')}
  }
`;
